import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M20 22h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 15v2h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 19.5V15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 8v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 2h2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 11V9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 22h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 17h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 22H6.5a2.5 2.5 0 0 1 0-5H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 5v-.5A2.5 2.5 0 0 1 6.5 2H8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BookTemplate";
const BookTemplate = memo(themed(Icon));
export {
  BookTemplate
};
//# sourceMappingURL=book-template.js.map
